// start:ng42.barrel
import './reception-corporate-contacts.controller';
// end:ng42.barrel

